import mapBoxContainer from './index.vue';
import Vue from 'vue';

let mapInstance;
const mapBox = function(opts) {
  const MapConstructor = Vue.extend(mapBoxContainer);

  const mapWrap = document.createElement('div');
  mapWrap.className = 'map-box-warp';
  //   if (!mapInstance) {

  //   }
  mapInstance = new MapConstructor({
    el: mapWrap
  });
  document.body.appendChild(mapInstance.$el);
  if (opts) {
    mapInstance.mode = opts.mode;
    mapInstance.lnglat = opts.lnglat;
    mapInstance.location = opts.location;
    mapInstance.title = opts.title;
    mapInstance.confirm = opts.confirm;
    mapInstance.confirmMsg = opts.confirmMsg;
  }
  mapInstance.visible = true;
};

export default {
  install(Vue, options) {
    Vue.prototype.$mapBox = mapBox;
  }
};




// WEBPACK FOOTER //
// ./src/libs/amap/index.js